import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

import NeuriteGrid from '../../components/neurite_grid';
import {
    openDialog, hideDialog, setSaveState
} from '../../actions';


const styles = theme => ({
    title: {
        margin: '5px 10px',
    },
    spinnerContainer: {
        width: '95%',
        height: 200,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});




class ZonaMaquinas extends React.Component {

    render() {
        const { classes } = this.props;

        return (
            <div >
                <Typography variant="h6" className={classes.title} color={'primary'}>Maquinas</Typography>

                {this.props.zonaMaquinas && !this.props.isLoading ?
                    <NeuriteGrid
                    id="z_m"
                        columns={[
                            { key: 'activa', name: 'Activa', type: 'bool', editable: false, dragable: false, width: 55 },
                            { key: 'tipo', name: 'Tipo', editable: false, dragable: false, width: 85 },
                            { key: 'modelo', name: 'Modelo', editable: false, dragable: false, width: 135 },
                            { key: 'maquina', name: 'Nombre', editable: false, dragable: false, width: 140 },
                            { key: 'regInterno', name: 'Reg.Interno', editable: false, dragable: false, width: 80 },
                            { key: 'matricula', name: 'Matrícula', editable: false, dragable: false, width: 80 },
                            { key: 'fIni', name: 'Fecha Ini.', editable: false, dragable: false, type: 'date', width: 80 },
                            { key: 'fEnd', name: 'Fecha Fin', editable: false, dragable: false, type: 'date', width: 80 },
                        ]}
                        rows={this.props.zonaMaquinas}
                        buttonEdit={false}
                        buttonDelete={false}
                        buttonNew={false}
                        height={200}
                        enableFilter={true}
                    />
                    : <div className={classes.spinnerContainer}> <CircularProgress className={classes.spinner} color="primary" /> </div>}
            </div>
        );
    };

};

ZonaMaquinas.propTypes = {
    //state
    zonaMaquinas: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    //dispatch
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        zonaMaquinas: state.zonaMaquinas.zonaMaquinas,
        isLoading: state.zonaMaquinas.isLoading,
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDialog,
        hideDialog,
        setSaveState
    }, dispatch);
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ZonaMaquinas));